import { ThemeUICSSObject } from 'theme-ui';

import { THeadingVariants } from '../theme';

export const headingStyles: Record<THeadingVariants, ThemeUICSSObject> = {
  mega: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'tighter',
    fontSize: 'mega',
  },
  h1: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'tighter',
    fontSize: 'h1',
  },
  h2: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'normal',
    fontSize: 'h2',
  },
  h3: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'normal',
    fontSize: 'h3',
  },
  h4: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'normal',
    fontSize: 'h4',
  },
  h5: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'normal',
    fontSize: 'h4',
  },
  h6: {
    color: 'text',
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'normal',
    fontSize: 'h4',
  },
};
